import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {Breadcrumbs} from "models/SearchState"
import {checkIfMerchandisedUrl} from "@next/utils"
import connect from "./connect"
import {httpUrlTrimmer} from "../../utils/httpUrlTrimmer"

export interface LoadingCoverProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    itemsRequestPending: boolean
    breadcrumbs: Breadcrumbs
    url: string
    testId?: string
    ariaValueText?: string
}

const LoadingCover = memo(
    ({templating, testId, ariaValueText, itemsRequestPending, breadcrumbs, url}: LoadingCoverProps) => {
        const Component = useTemplatedComponent(templating, MANIFEST)
        const isMerchandisedUrl = checkIfMerchandisedUrl(httpUrlTrimmer(url))
        return (
            <Suspense>
                <Component
                    testId={testId}
                    ariaValueText={ariaValueText}
                    itemsRequestPending={itemsRequestPending}
                    breadcrumbsEnabled={breadcrumbs.enabled}
                    isMerchandisedUrl={isMerchandisedUrl}
                />
            </Suspense>
        )
    },
)
LoadingCover.displayName = "LoadingCover"
export default connect(LoadingCover)
